export const getOneDay = () => {
  return new Date().getTime() + 86400000
}
export const getTenDay = () => {
  return new Date().getTime() + 864000000
}
